import { FormulierDto } from '../../../api';
import { documentApi } from '../../../api/apiClient';
import { FormulierProcessDependencies } from '../dependencies';
import { resultaatPreAdviesFormulierVraag } from './resultaatPreAdviesFormulierVraag'

export const submitPreadviesFormulier = async (values: any, fileName: string, deps: FormulierProcessDependencies) => {
  await resultaatPreAdviesFormulierVraag(values, deps)

  const formulier: FormulierDto = {
    hasBackendErrors: false,
    gegevensWerknemer: values?.gegevensWerknemer!,
    gegevensWerkgever: values?.gegevensWerkgever!,
    gegevensUitvoerderPreAdvies: values?.gegevensUitvoerderPreAdvies!,
    resultaatPreAdvies: values?.resultaatPreAdvies!,
  };

  try {
    let hasReturnedSuccessful = true;
    const response = await documentApi.documentUploadPreadviesFormulier(formulier, fileName)
    .catch(reason => {
      hasReturnedSuccessful = false;
      console.error("documentUploadPreadviesFormulier failed with reason object: ", reason);
    });

    const dossierId = response!.data! as number;

    if (hasReturnedSuccessful && !isNaN(dossierId)) {
      deps.dispatch(s => ({
        ...s,
        isSuccessful: true,
      }));

      return dossierId;
    }
    const error = new Error("documentUploadPreadviesFormulier failed or did not return a number");
    console.error(error.message);
    throw error;
  } catch (e) {
    deps.dispatch(s => ({
      ...s,
      isReady: false,
      isSuccessful: false,
      isComplete: false,
    }));

    return NaN;
  }
};
